import { observer } from "mobx-react-lite";
import { Grid } from "@mui/material";
import SmartAppStep from "../../components/apps/SmartAppStep";
import VideoConversionStatus from "e.sic-platform.webclient/src/services/conversion/VideoConversionStatus";
import SmartAppBase from "../../components/apps/SmartAppBase";
import { Cameraswitch } from "@mui/icons-material";
import useThemeService from 'e.sic-platform.webclient/src/services/theme-service/ThemeService';
import { conversionApp } from "../../services/apps/SmartApps";

export default observer(function VideoConversionPage() {
  const videoConversion = conversionApp.services.videoConversion!;
  const {themeClass} = useThemeService();

  if (videoConversion.isConverted) conversionApp.setStep(3);
  
  return (
    <SmartAppBase 
      appStorage={conversionApp}
      icon={{
        svg: Cameraswitch,
        textKey: "RunVideoConversionButton.run",
        className: themeClass(["icon-custom"]),
      }}
    >
      <SmartAppStep
        step={2}
        titleKey="videoConversion.conversion.title"
        descriptionKey="videoConversion.conversion.description"
        visible={videoConversion.fileId !== undefined}
        appStorage={conversionApp}
      >
        <Grid item xs={12} sm={12}>
          <VideoConversionStatus
            files={[
              {
                id: 1,
                filename: videoConversion?.name!,
                sas: videoConversion?.sas!,
                status: videoConversion?.status!,
              },
            ]}
          />
        </Grid>
      </SmartAppStep>
      <SmartAppStep
        titleKey="videoConversion.converted.title"
        descriptionKey="videoConversion.converted.description"
        step={3}
        appStorage={conversionApp}
      />
    </SmartAppBase>
  )
})